import { useParams, useNavigate } from 'react-router-dom'
import { useQuery } from 'react-query'
import { api } from '../../../../services/api'

export function useIdNota() {
  const { id, sequency } = useParams()
  const navigate = useNavigate()

  const fetchNota = async () => {
    try {
      const response = await api.get(`/ordem-producao/listar-status/${id}/${sequency}`)
      return response.data
    } catch (error) {
      throw new Error(error.message || 'Erro ao buscar dados do pedido')
    }
  }

  const { data, isLoading, isError } = useQuery(['nota', id, sequency], fetchNota, {
    retry: 1,
    staleTime: 1000 * 60 * 5, // 5 minutos
  })

  const options = [
    {
      label: 'Aprovação Piloto',
      to: `/status-pedido/${id}/${sequency}/aprovacao-piloto`,
      bg: '#25c07c',
      icon: 'MdOutlineCameraAlt',
    },
    {
      label: 'Itens do Pedido',
      to: `/status-pedido/${id}/${sequency}/itens-pedido`,
      bg: '#5ac8fa',
      icon: 'BsClipboardCheck',
    },
    {
      label: 'Recebimento de Troca',
      to: `/status-pedido/${id}/${sequency}/recebimento-troca`,
      bg: '#2484e4',
      icon: 'BsBoxSeam',
    },
    {
      label: 'Solicitar Troca',
      to: `/status-pedido/${id}/${sequency}/solicitar-troca`,
      bg: '#f5a623',
      icon: 'HiOutlineClipboardCopy',
    },
  ]

  return {
    id,
    sequency,
    data,
    isLoading,
    isError,
    navigate,
    options,
  }
}
